export default __webpack_public_path__ + "static/media/user-circle.3497d28f.svg";